import $ from 'jquery';
import config from './../../../config';

// Save Get Approvals
export function get_leave_approvals( users, ap ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'approvals/',
			data: {
				method: 'GET_LEAVE_APPROVALS',
				users: users,
				ap: ap
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_APPROVALS",
				approval: response
			})
		})

	}
}

export function set_leave_approvals( user_id, leave_id, remarks ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'approvals/',
			data: {
				method: 'SET_LEAVE_APPROVALS',
				user_id: user_id,
				leave_id: leave_id,
				remarks: remarks
            }
		})
		.then(function (response) {
			dispatch({
				type: "SET_LEAVE_APPROVALS",
				approval: response
			})
		})

	}
}

export function get_leave_type(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'leave/',
			data: {
				method: 'GET_LEAVE_TYPE',
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LEAVE_TYPE_APPROVALS",
				approval: response
			})
		})

	}
}



export function set_leave_type( leave_id, leave_type_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'approvals/',
			data: {
				method: 'SET_LEAVE_TYPE',
				leave_id: leave_id,
				leave_type_id: leave_type_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "SET_LEAVE_TYPE",
				approval: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/approvals/actions/approvals.action.js